import type { IconName } from "../atoms/Icon";
import iconSuffixMap from "./fa-icon-suffix-map.json";

export const ICON_SUFFIX_TO_PLURA_NAME: Record<string, IconName> =
    iconSuffixMap as Record<string, IconName>;

const SUFFIX_ICON_CLASS: Record<string, string> = {
    "arrow-left": "rotate-180",
    "arrow-up": "-rotate-90",
    "caret-down": "rotate-180",
    "chevron-left": "rotate-90",
    "chevron-right": "-rotate-90",
    "chevron-up": "rotate-180",
    "rotate-left": "-scale-x-100",
};

function remixToPlura(className: string): { name: IconName; iconClass?: string } | null {
    if (!className.startsWith("ri-")) return null;
    if (className.includes("arrow-right")) return { name: "arrow" };
    if (className.includes("checkbox-circle")) return { name: "check-circle" };
    return { name: "help" };
}

/** Resolves landing-app Font Awesome (or legacy Remix `ri-*`) class strings to shared `Icon` names. */
export function faClassToPluraIcon(faClass: string): { name: IconName; iconClass?: string } {
    const s = faClass.replace(/\s+/g, " ").trim();
    const remix = remixToPlura(s);
    if (remix) return remix;
    const parts = s.split(" ");
    let iconToken = "";
    for (let i = parts.length - 1; i >= 0; i--) {
        const p = parts[i];
        if (p.startsWith("fa-") && !["fa-solid", "fa-regular", "fa-brands"].includes(p)) {
            iconToken = p.slice(3);
            break;
        }
    }
    if (!iconToken) return { name: "help" };
    const name: IconName = ICON_SUFFIX_TO_PLURA_NAME[iconToken] ?? "help";
    const iconClass = SUFFIX_ICON_CLASS[iconToken];
    return { name, iconClass };
}
